import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable({
  providedIn: 'root'
})
export class LabelsService extends RestfulService<Models.Label> {

  constructor(public restService: RestService) {
    super(Models.Label);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('labels');
  }
}
